<template>
  <main
    role="main"
    class="col content-spacing"
    style="max-width: 88% !important"
  >
    <section>
      <PageHeader pageTitle="Relatório de Leads" style="padding-top: 1rem;">
        <div style="display: flex; gap: 0.5rem">
          <QualifiedLeadsPrimaryCnaeSelect v-model="cnaeList" />
        </div>

        <div style="display: flex; gap: 0.5rem">
          <b-form-group label="Data inicial">
            <b-form-datepicker
              locale="pt-BR"
              aria-label="Escolha a data inicial"
              v-model="startDate"
              title="Selecione a data inicial"
              label-no-date-selected="Nenhuma data selecionada"
            />
          </b-form-group>

          <b-form-group label="Data final">
            <b-form-datepicker
              locale="pt-BR"
              aria-label="Escolha a data final"
              v-model="endDate"
              :min="startDate"
              title="Selecione a data final"
              label-no-date-selected="Nenhuma data selecionada"
            />
          </b-form-group>
        </div>

        <BaseButtonComponent
          variant="primary-action"
          style="padding: 1px 12px;"
          @click="getLeads"
        >
          Buscar
        </BaseButtonComponent>
      </PageHeader>
    </section>

    <b-skeleton-table
      v-if="isLoading"
      animation="wave"
      style="margin-top: 2rem"
      :rows="5"
      :columns="12"
      :table-props="{ bordered: true, striped: true }"
    />
    <LeadsReportTable v-else :list="leads" :isLoading="isLoading" />
  </main>
</template>

<script>
import {
  LeadsReportTable,
  QualifiedLeadsPrimaryCnaeSelect,
} from '../../modules/leads/components';
import { SelectYear } from '../../ui/selects';
import { BaseButtonComponent } from '../../ui/buttons';
import { PageHeader } from '../../ui/page-header';
import { Api } from '../../vue/api';
const API = new Api();

export default {
  data() {
    return {
      isLoading: false,
      leads: [],
      cnaeList: [],
      startDate: null,
      endDate: null,
    };
  },
  components: {
    PageHeader,
    QualifiedLeadsPrimaryCnaeSelect,
    SelectYear,
    BaseButtonComponent,
    LeadsReportTable,
  },
  mounted() {
    this.cnaeList = [];
    this.getLeads();
  },
  methods: {
    showToast(message, title = 'Aviso', variant = 'info') {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
      });
    },
    validateDates() {
      return (
        (!this.startDate && !this.endDate) ||
        (this.startDate && this.endDate && this.endDate >= this.startDate)
      );
    },
    async getLeads() {
      this.leads = [];
      if (!this.validateDates()) {
        this.showToast(
          'Por favor, selecione um período válido de data',
          'Erro',
          'danger',
        );
        return;
      }

      this.isLoading = true;
      try {
        const { model, ok, errors } = await API.post('/execute', {
          path: '/lead-management/leads-report',
          method: 'get',
          data: {
            cnaeList: this.cnaeList,
            startDate: this.startDate,
            endDate: this.endDate,
          },
        });

        if (!ok) {
          this.showToast(errors.message, 'Erro', 'danger');
          return;
        }

        if (!model || !model.length) {
          this.showToast('Nenhum lead encontrado.', 'Aviso', 'warning');
          return;
        }

        this.leads = model.map(lead => ({
          primaryCNAECode: lead.cnae,
          primaryCNAEDescription: lead.primary_CNAE_description,
          creationDate: lead.created_date,
          totalLeads: lead.total_leads,
          totalQualified: lead.total_qualified,
          totalClosed: lead.total_closed,
          totalMT: lead.total_mt,
          totalLowConsumption: lead.total_low_consumption,
          totalSCEEWithoutICMSWithBalance:
            lead.total_scee_without_icms_with_balance,
          totalSCEEExemptWithBalance: lead.total_scee_exempt_with_balance,
          totalNightIrrigator: lead.total_night_irrigator,
          totalNoHistory: lead.total_no_history,
        }));
      } catch (error) {
        this.showToast('Erro ao buscar leads', 'Erro', 'danger');
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
